module.exports = __webpack_public_path__ + "img/topAndDownArrows.2f548f22.svg";